import { computed } from '@vue/composition-api'
import { createVuexHelpers } from 'vue2-helpers'

export const useUserCompanyRLS = () => {
  const { useGetters } = createVuexHelpers()
  const { user } = useGetters(['user'])

  const brokerIds = computed(() => {
    const { company } = user.value || {}

    if (!company) return []

    return company.rls_broker_ids || []
  })

  const coverholderIds = computed(() => {
    const { company } = user.value || {}

    if (!company) return []

    return company.rls_coverholder_ids || []
  })

  const tpaIds = computed(() => {
    const { company } = user.value || {}

    if (!company) return []

    return company.rls_tpa_ids || []
  })

  const underwriterIds = computed(() => {
    const { company } = user.value || {}

    if (!company) return []

    return company.rls_underwriter_ids || []
  })

  return {
    brokerIds,
    coverholderIds,
    tpaIds,
    underwriterIds
  }
}
